import {
  getEstimateContractByIdAPI,
  updatePortDistanceForContractAPI,
  resetPortDistanceForContractAPI,
  estimateContractcargoPriceAPI,
  updateEstimateCostAPI,
  deleteCargoForEstimateByIdAPI,
  addCargoForEstimateAPI,
  createEstimateContractAPI,
  updateVesselContractAPI,
  updateVesselPortDistanceForContractAPI,
} from "../../api";

export const getEstimateContractByIdApi = (data) =>
  getEstimateContractByIdAPI(data);

export const updatePortDistanceForContractApi = (data) =>
  updatePortDistanceForContractAPI(data);

export const resetPortDistanceForContractApi = (data) =>
  resetPortDistanceForContractAPI(data);

export const estimateContractcargoPriceApi = (data) =>
  estimateContractcargoPriceAPI(data);

export const updateEstimateCostApi = (data) =>
  updateEstimateCostAPI(data);

export const deleteCargoFromEstimateByIdApi = (data) =>
  deleteCargoForEstimateByIdAPI(data);

export const addCargoForEstimateApi = (data) =>
  addCargoForEstimateAPI(data);

export const createEstimateContractApi = (data) =>
  createEstimateContractAPI(data);

export const updateVesselContractApi = (idObj, formPayload) =>
  updateVesselContractAPI(idObj, formPayload);

export const updateVesselPortDistanceForContractApi = (data) =>
  updateVesselPortDistanceForContractAPI(data);
